<template>
  <v-container fluid>
    <v-form ref="form" @submit.prevent="save(false)">
      <v-row>
        <form-header :title="isEditing ?'Modifica lezione' : 'Nuova lezione'"
                     @back="$router.replace(`/kits/${$route.params.kitId}/products/${$route.params.productId}/lessons`)" @saveback="save(true)" :loading="loading"></form-header>


        <v-col cols="12" lg="6" xl="5">
          <media-field label="Video esplicativo" v-model="editingItem.video_id" media-type="video" :aspect-ratio="16/9" required></media-field>
          <v-switch
              label="Android video mode"
              v-model="editingItem.android_video_mode"
          ></v-switch>
        </v-col>
        <v-col cols="12">
          <h3>Info lezione</h3>
        </v-col>
        <v-col cols="12" lg="6">
          <v-text-field label="Titolo*" v-model="editingItem.title.it" :rules="[rules.required]"></v-text-field>
        </v-col>
        <v-col cols="12" class="py-0"></v-col>
        <v-col cols="12" lg="6">
          <v-textarea label="Descrizione" v-model="editingItem.description.it" ></v-textarea>
        </v-col>


        <v-col cols="12">
          <h3>Contenuto lezione</h3>
          <v-table class="mt-3 border rounded" striped="even" density="compact" >
            <thead>
            <tr>
              <th class="text-center"><v-checkbox v-model="selectAll" @update:model-value="selectAllChange" hide-details></v-checkbox></th>
              <th class="text-left">Esercizio</th>
              <th class="text-left">Tempo di lavoro (sec)</th>
              <th class="text-left">Tempo di recupero (sec)</th>
              <th class="text-center" style="width: 60px">
                <v-tooltip location="top">
                  <template #activator="{props}">
                    <v-btn icon="mdi-plus"  color="primary" @click="editSchedule()" v-bind="props"></v-btn>
                  </template>
                  <p>Aggiungi esercizio</p>
                </v-tooltip>

              </th>
              <th class="text-center" style="width: 60px">
                <v-tooltip location="top">
                  <template #activator="{props}" >
                    <v-btn icon="mdi-pencil-box-multiple"  color="primary" :disabled="!multipleScheduleSelected" @click="multipleEditForm = true" v-bind="props"></v-btn>
                  </template>
                  <p>Modifica multipla</p>
                </v-tooltip>

              </th>
              <th class="text-center" style="width: 60px">
                <v-tooltip location="top">
                  <template #activator="{props}">
                    <v-btn icon="mdi-delete-sweep" color="primary" :disabled="!multipleScheduleSelected" @click="removeScheduleMultiple()" v-bind="props" ></v-btn>
                  </template>
                  <p>Cancellazione multipla</p>
                </v-tooltip>

              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, i) in editingItem.schedules" :key="i" :class="i === editingScheduleIndex ? 'warning' : ''">
              <td><v-checkbox v-model="selectedIndexes[i]" @change="editingScheduleIndex = -1;" hide-details></v-checkbox></td>
              <td>{{ getExerciseName(item.exercise_id) }}</td>
              <td>{{ item.work_time }}</td>
              <td>{{ item.recovery_time }}</td>
              <td>
                <v-tooltip location="left">
                  <template #activator="{props}">
                    <v-btn color="primary" variant="text" icon="mdi-content-copy" v-on:click="cloneSchedule(i)" v-bind="props"></v-btn>
                  </template>
                  <p>Duplica</p>
                </v-tooltip>

              </td>
              <td>
                <v-btn color="primary" variant="text" icon="mdi-pencil" v-on:click="editSchedule(i)"></v-btn>
              </td>
              <td>
                <v-btn color="error" variant="text" icon="mdi-close" v-on:click="requestScheduleDelete(i)"></v-btn>
              </td>
            </tr>
            </tbody>
          </v-table>
        </v-col>


        <v-dialog v-model="dialog" max-width="900">
          <v-card>
            <v-form ref="scheduleForm" @submit.prevent="addSchedule()">
              <v-card-title>
                Sessioni di esercizio nella lezione
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="6" lg="4" >
                    <v-autocomplete
                        label="Esercizio*" v-model="editingSchedule.exercise_id" hide-details
                        :items="exerciseOptions" :rules="[rules.required]"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="6" lg="4">
                    <v-text-field
                        label="Tempo di lavoro*" :step="1" :min="1" type="number"
                        v-model="editingSchedule.work_time" :rules="[rules.required, rules.minInt(1)]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" lg="4" >
                    <v-text-field
                        label="Tempo di recupero*" :step="1" :min="1" type="number"
                        v-model="editingSchedule.recovery_time" :rules="[rules.required, rules.minInt(1)]"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="dialog = false;">Annulla</v-btn>
                <v-btn color="primary" type="submit" >Salva</v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>


        <v-dialog v-model="multipleEditForm" persistent max-width="300">
          <v-card>
            <v-form ref="multiEditForm" @submit.prevent="editMultiple()">
              <v-card-title class="headline">Modifica multipla</v-card-title>
              <v-card-text>
                <v-container fluid>
                  <v-row>
                    <v-col cols="12" class="d-flex align-center">
                      <v-checkbox v-model="enableFormExercise" label="Abilita"></v-checkbox>
                      <v-autocomplete
                          label="Esercizio" :disabled="!enableFormExercise"
                          v-model="formExerciseId" :items="exerciseOptions"
                          :rules="enableFormExercise ? [rules.required] : []"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12">
                      <v-checkbox v-model="enableFormWorkTime" label="Abilita"></v-checkbox>
                      <v-text-field
                          :disabled="!enableFormWorkTime" label="Tempo di lavoro"
                          :step="1" type="number" v-model="formWorkTime"
                          :rules="enableFormWorkTime ? [rules.required] : []"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-checkbox v-model="enableFormRecoveryTime" label="Abilita"></v-checkbox>
                      <v-text-field
                          :disabled="!enableFormRecoveryTime" label="Tempo di recupero"
                          :step="1" type="number" v-model="formRecoveryTime"
                          :rules="enableFormRecoveryTime ? [rules.required] : []"
                      ></v-text-field>
                    </v-col>

                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="multipleEditForm = false">Annulla</v-btn>
                <v-btn color="primary" variant="elevated" type="submit">Salva</v-btn>
              </v-card-actions>
            </v-form>

          </v-card>
        </v-dialog>

        <form-footer @back="$router.replace(`/kits/${$route.params.kitId}/products/${$route.params.productId}/lessons`)" @saveback="save(true)" :loading="loading"></form-footer>
      </v-row>
    </v-form>
  </v-container>
</template>

<script lang="ts">
import utils from "../utils";
import rules from "../utils/rules";
import FormHeader from "@/components/FormHeader.vue";
import FormFooter from "@/components/FormFooter.vue";
import {computed, inject, onMounted, ref, useTemplateRef} from "vue";
import type {Auth} from "@/plugins/auth.ts";
import {type Messages, Msg} from "@/plugins/messages.ts";
import type {Globals} from "@/plugins/globals.ts";
import {useRoute, useRouter} from "vue-router";
import api from "@/api";
import {VForm} from "vuetify/components";
import type {Exercise, Lesson, Schedule} from "@/models.ts";
import MediaField from "@/components/MediaField.vue";
export default {
  components: {MediaField, FormFooter, FormHeader},
  setup() {
    const auth = inject('auth') as Auth
    const messages = inject('messages') as Messages
    const globals = inject('globals') as Globals
    const route = useRoute()
    const router = useRouter()
    const form = useTemplateRef<typeof VForm>('form')
    const multiEditForm = useTemplateRef<typeof VForm>('multiEditForm')
    const scheduleForm = useTemplateRef<typeof VForm>('scheduleForm')
    const loading = ref(false)
    const dialog = ref(false)
    const selectAll = ref(false)
    const multipleEditForm = ref(false)
    const enableFormExercise = ref(false)
    const enableFormWorkTime = ref(false)
    const enableFormRecoveryTime = ref(false)
    const editingItem = ref<Lesson>({
      android_video_mode: false,
      description: { it : '' },
      product_id: "",
      schedules: [],
      title: { it : '' },
      video_id: ""
    })

    const formExerciseId = ref('')
    const formWorkTime = ref('')
    const formRecoveryTime = ref('')

    const selectedIndexes = ref<boolean[]>([])

    const editingScheduleIndex = ref<number>(-1)
    const editingSchedule = ref<Schedule>({
      exercise_id: "", recovery_time: 0, work_time: 0
    })

    const loadData = async () => {
      loading.value = true;
      let id = route.params.id as string;
      const res = await api.get<Lesson>('lessons', id)
      if(!res.success) {
        loading.value = false;
        messages.error(res.message ?? Msg.serverError)
        await router.replace('/lessons')
        return
      }
      editingItem.value = res.data!
      loading.value = false;
    }

    onMounted(async ()=>{
      await globals.waitForInit
      await router.isReady()
      await Promise.all([
          globals.refreshEmpty('media'),
          globals.refreshEmpty('exercises'),
      ])

      editingItem.value.product_id = route.params.productId as string

      if (route.params.id !== "new") {
        await loadData();
      }
    })




    return {
      dialog,
      form,
      scheduleForm,
      multiEditForm,
      loading,
      isEditing : computed(()=> route.params.id !== "new"),
      editingItem,
      editingSchedule,
      editingScheduleIndex,
      selectedIndexes,
      exerciseOptions : computed(()=> globals.exercises.value.map(i => {
        return { title : i.title.it, value : i._id }
      })),
      getExerciseName(id:string):string {
        const ex = globals.exercises.value.find(i => i._id === id)
        return ex ? ex.title.it : id
      },
      editSchedule(i?:number) {
        editingScheduleIndex.value = i !== undefined ? i : -1;
        editingSchedule.value = editingScheduleIndex.value >= 0 ? {...editingItem.value.schedules[editingScheduleIndex.value]!} : {  exercise_id: "", recovery_time: 0, work_time: 0 }
        dialog.value = true
      },
      cloneSchedule(i:number) {
        const original = editingItem.value.schedules[i]!
        const clone = {...original}
        editingItem.value.schedules.push(clone);
      },
      requestScheduleDelete(i:number) {
        messages.requestConfirm('Richiesta conferma','Sei sicuro di voler eliminare questa sessione di esercizio?', false, ok => {
          if(ok) editingItem.value.schedules.splice(i,1)
        })
      },
      removeScheduleMultiple() {
        messages.requestConfirm('Richiesta conferma','Sei sicuro di voler eliminare tutte le sessioni di esercizio selezionate?', false, ok => {
          if(ok) editingItem.value.schedules = editingItem.value.schedules.filter((_, i) => selectedIndexes.value[i])
        })
      },
      multipleEditForm,
      selectAll,
      selectAllChange() {
        selectedIndexes.value = Array.from({length: editingItem.value.schedules.length}, (v, k) => selectAll.value);
        editingScheduleIndex.value = -1;
        //this.tableRefresh++;
      },
      multipleScheduleSelected : computed(()=>{
        return selectedIndexes.value.find(i => i) !== undefined
      }),
      async addSchedule() {
        editingSchedule.value.work_time = utils.toInt(editingSchedule.value.work_time, 0)
        editingSchedule.value.recovery_time = utils.toInt(editingSchedule.value.recovery_time, 0)
        const { valid } = await scheduleForm.value!.validate()
        if(!valid) return
        if(editingScheduleIndex.value >= 0) {
          editingItem.value.schedules[editingScheduleIndex.value] = {...editingSchedule.value}
        } else {
          editingItem.value.schedules.push({...editingSchedule.value})
        }
        editingSchedule.value = {exercise_id: '', recovery_time: 0, work_time: 0}
        editingScheduleIndex.value = -1;
        dialog.value = false;
      },
      async editMultiple() {
        const { valid } = await multiEditForm.value!.validate()
        if(!valid) return;

        selectedIndexes.value.forEach((selected, i) => {
          if(!selected) return
          if(enableFormExercise.value) {
            editingItem.value.schedules[i].exercise_id = formExerciseId.value
          }
          if(enableFormWorkTime.value) {
            editingItem.value.schedules[i].work_time = utils.toInt(formWorkTime.value, 0)
          }
          if(enableFormRecoveryTime.value) {
            editingItem.value.schedules[i].recovery_time = utils.toInt(formRecoveryTime.value, 0)
          }
        })
      },
      enableFormExercise,
      enableFormWorkTime,
      enableFormRecoveryTime,
      formExerciseId,
      formWorkTime,
      formRecoveryTime,
      rules,
      formatDate : utils.formatDate,
      async save(goBackAfterSave:boolean) {
        const v = await form.value!.validate()
        if(!v.valid) return;
        loading.value = true;
        const res = await api.save<Lesson>('lessons', editingItem.value)
        loading.value = false;
        if(!res.success) {
          messages.error(res.message ?? Msg.serverError)
          if(res.status === 401) {
            auth.logout()
          }
          return
        }
        editingItem.value = res.data!
        messages.success("lezione salvato")
        if(goBackAfterSave) {
          await router.replace(`/kits/${route.params.kitId}/products/${route.params.productId}/lessons`)
        } else if(route.params.id === 'new'){
          await router.replace(`/kits/${route.params.kitId}/products/${route.params.productId}/lessons/${editingItem.value._id}`)
        }
      }
    };
  }
};
</script>

<style scoped></style>
